module.exports = __webpack_public_path__ + "img/image14.6ea90132.webp";